import { render, staticRenderFns } from "./promoterAgentReviewe.vue?vue&type=template&id=755d31d5&scoped=true"
import script from "./promoterAgentReviewe.vue?vue&type=script&lang=js"
export * from "./promoterAgentReviewe.vue?vue&type=script&lang=js"
import style0 from "./promoterAgentReviewe.vue?vue&type=style&index=0&id=755d31d5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d31d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755d31d5')) {
      api.createRecord('755d31d5', component.options)
    } else {
      api.reload('755d31d5', component.options)
    }
    module.hot.accept("./promoterAgentReviewe.vue?vue&type=template&id=755d31d5&scoped=true", function () {
      api.rerender('755d31d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/promoterAgentReviewe.vue"
export default component.exports